module.exports = require('./helpers/bundle-url').getBundleURL('iqneu') + "logo.c51670a8.svg";